/*
 * Deckaura mobile remediation layer (Oct 2026 audit).
 * Progressive enhancement only: every handler checks that its target exists,
 * so pages without the related component are untouched.
 */
(function () {
  'use strict';
  if (window.__daMobile2026) return;
  window.__daMobile2026 = true;

  var doc = document;
  var LANG = String(doc.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
  var COPY = {
    quotaPrice: {
      en: 'AI-assisted decision reading with automated checks · {price}',
      tr: 'Otomatik kontrollerden geçen, yapay zekâ destekli karar yorumu · {price}',
      de: 'KI-gestützte Entscheidungsdeutung mit automatischen Prüfungen · {price}',
      es: 'Lectura de decisión con ayuda de IA y comprobaciones automáticas · {price}',
      pt: 'Leitura de decisão com apoio de IA e verificações automáticas · {price}'
    },
    deckFull: {
      en: '{n} cards chosen. Tap “{cta}” to see them.',
      tr: '{n} kart seçildi. Görmek için “{cta}” düğmesine dokunun.',
      de: '{n} Karten gewählt. Tippe auf „{cta}“, um sie zu sehen.',
      es: 'Ya elegiste {n} cartas. Toca «{cta}» para verlas.',
      pt: 'Você escolheu {n} cartas. Toque em “{cta}” para vê-las.'
    }
  };

  function copy(key, vars) {
    var set = COPY[key] || {};
    var text = set[LANG] || set.en || '';
    Object.keys(vars || {}).forEach(function (name) {
      text = text.split('{' + name + '}').join(String(vars[name]));
    });
    return text;
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function smooth() {
    return reducedMotion() ? 'auto' : 'smooth';
  }

  function pulse(el) {
    if (!el) return;
    el.classList.remove('da-pulse');
    void el.offsetWidth;
    el.classList.add('da-pulse');
    window.setTimeout(function () { el.classList.remove('da-pulse'); }, 2400);
  }

  var toastTimer = 0;
  function toast(message) {
    if (!message || !doc.body) return;
    var node = doc.querySelector('.da-toast');
    if (!node) {
      node = doc.createElement('div');
      node.className = 'da-toast';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      doc.body.appendChild(node);
    }
    node.textContent = message;
    node.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { node.classList.remove('is-visible'); }, 3200);
  }

  function isTextField(el) {
    if (!el || !el.tagName) return false;
    if (el.tagName === 'TEXTAREA') return true;
    if (el.tagName !== 'INPUT') return false;
    return /^(text|search|email|tel|number|url|password)$/i.test(el.type || 'text');
  }

  /* Sticky bars step aside while the on-screen keyboard is open. */
  doc.addEventListener('focusin', function (ev) {
    if (isTextField(ev.target) && doc.body) doc.body.classList.add('da-kb-open');
  });
  doc.addEventListener('focusout', function (ev) {
    if (!isTextField(ev.target)) return;
    window.setTimeout(function () {
      if (!isTextField(doc.activeElement) && doc.body) doc.body.classList.remove('da-kb-open');
    }, 80);
  });

  /* ---------- Free Tarot ---------- */
  function initFreeTarot() {
    if (!doc.querySelector('[data-ft-scope]')) return;

    /* Every in-page purchase button counts: the checkout button and the limit-mode offer button. */
    var INLINE_CTA = '.ft-intent__continue, .ft-limit-offer';
    var observed = [];
    var inView = [];
    var inlineObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var at = inView.indexOf(entry.target);
            if (entry.isIntersecting && at < 0) inView.push(entry.target);
            if (!entry.isIntersecting && at >= 0) inView.splice(at, 1);
          });
          doc.body.classList.toggle('da-ft-inline-cta', inView.length > 0);
        }, { threshold: 0.01, rootMargin: '0px 0px -24px 0px' })
      : null;

    function syncInlineCta() {
      if (!inlineObserver) return;
      observed = observed.filter(function (el) {
        if (doc.documentElement.contains(el)) return true;
        inlineObserver.unobserve(el);
        var at = inView.indexOf(el);
        if (at >= 0) inView.splice(at, 1);
        return false;
      });
      Array.prototype.forEach.call(doc.querySelectorAll(INLINE_CTA), function (el) {
        if (observed.indexOf(el) >= 0) return;
        observed.push(el);
        inlineObserver.observe(el);
      });
      doc.body.classList.toggle('da-ft-inline-cta', inView.length > 0);
    }

    function tagFinalCta() {
      doc.querySelectorAll('[data-rv2-act="top"]').forEach(function (button) {
        var section = button.closest('section');
        if (section) section.classList.add('da-ft-final-cta');
      });
    }

    function syncQuotaPrice() {
      var wall = doc.querySelector('.ft-quota-wall');
      if (!wall) return;
      var priceNode = doc.querySelector('[data-rv2-bind="focusedPriceLabel"]');
      var price = priceNode ? String(priceNode.textContent || '').trim() : '';
      var line = wall.querySelector('.da-ft-quota-price');
      if (!/\d/.test(price)) {
        if (line && !line.hidden) line.hidden = true;
        return;
      }
      if (!line) {
        line = doc.createElement('p');
        line.className = 'da-ft-quota-price';
        var links = wall.querySelector('.ft-quota-wall__links');
        if (links && links.parentNode) links.parentNode.insertBefore(line, links);
        else wall.appendChild(line);
      }
      var text = copy('quotaPrice', { price: price });
      if (line.textContent !== text) line.textContent = text;
      if (line.hidden) line.hidden = false;
    }

    function openResultCard(index) {
      var details = doc.querySelector('details.ft-card-details');
      if (!details) return;
      details.open = true;
      window.requestAnimationFrame(function () {
        details.scrollIntoView({ block: 'start', behavior: smooth() });
        var rail = details.querySelector('.ft-result-rail');
        var cards = details.querySelectorAll('.ft-result-card');
        var card = cards[index] || cards[0];
        if (rail && card) {
          var left = card.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft - 4;
          rail.scrollTo({ left: Math.max(0, left), behavior: smooth() });
        }
      });
    }

    doc.addEventListener('click', function (ev) {
      var target = ev.target;
      if (!target || !target.closest) return;
      var thumb = target.closest('[data-ft-result-thumb]');
      if (thumb) {
        var holder = thumb.closest('[data-rv2-idx]');
        openResultCard(holder ? Number(holder.getAttribute('data-rv2-idx')) || 0 : 0);
        return;
      }
      var barCopy = target.closest('.ft-sticky-offer__copy');
      if (barCopy) {
        var bar = barCopy.closest('.ft-sticky-offer');
        var buy = bar && bar.querySelector('[data-rv2-act="barcheckout"]');
        if (buy && buy.getAttribute('aria-disabled') !== 'true') buy.click();
      }
    });

    doc.addEventListener('ft:deck-complete', function () {
      window.setTimeout(function () {
        var reveal = doc.querySelector('[data-rv2-act="reveal"]');
        if (!reveal) return;
        reveal.scrollIntoView({ block: 'center', behavior: smooth() });
        pulse(reveal);
      }, 260);
    });

    doc.addEventListener('ft:deck-full', function (ev) {
      var reveal = doc.querySelector('[data-rv2-act="reveal"]');
      if (!reveal) return;
      var total = ev && ev.detail && ev.detail.total ? ev.detail.total : 3;
      toast(copy('deckFull', { n: total, cta: String(reveal.textContent || '').replace(/\s+/g, ' ').trim() }));
      reveal.scrollIntoView({ block: 'center', behavior: smooth() });
      pulse(reveal);
    });

    var pending = 0;
    function refresh() {
      pending = 0;
      syncInlineCta();
      tagFinalCta();
      syncQuotaPrice();
    }
    function schedule() {
      if (pending) return;
      pending = window.setTimeout(refresh, 150);
    }
    refresh();
    if ('MutationObserver' in window) {
      var scope = doc.querySelector('main') || doc.body;
      new MutationObserver(schedule).observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden'] });
    }
  }

  /* ---------- Mobile menu: one reading CTA at a time ---------- */
  function initMenu() {
    var sticky = doc.querySelector('.da-mobile-nav__sticky');
    var cardCta = doc.querySelector('.da-mobile-nav__reading a');
    if (!sticky || !cardCta || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { sticky.classList.toggle('da-is-redundant', entry.isIntersecting); });
    }, { threshold: 0.6 }).observe(cardCta);
  }

  /* ---------- Birth card result: card art opens its explanation ---------- */
  function initBirthCard() {
    var result = doc.getElementById('result');
    if (!result || !result.classList.contains('bc2-result')) return;
    function openDetails() {
      var details = result.querySelector('details.bc2-details:not(.bc2-focus-details)');
      if (!details) return;
      details.open = true;
      window.requestAnimationFrame(function () { details.scrollIntoView({ block: 'start', behavior: smooth() }); });
    }
    function prepare() {
      result.querySelectorAll('article.bc2-card img').forEach(function (img) {
        if (img.hasAttribute('data-da-zoomable')) return;
        img.setAttribute('data-da-zoomable', '');
        img.setAttribute('role', 'button');
        img.setAttribute('tabindex', '0');
        img.style.cursor = 'pointer';
      });
    }
    result.addEventListener('click', function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('article.bc2-card img')) openDetails();
    });
    result.addEventListener('keydown', function (ev) {
      if ((ev.key === 'Enter' || ev.key === ' ') && ev.target && ev.target.matches && ev.target.matches('img[data-da-zoomable]')) {
        ev.preventDefault();
        openDetails();
      }
    });
    prepare();
    if ('MutationObserver' in window) new MutationObserver(prepare).observe(result, { childList: true, subtree: true });
  }

  function init() {
    try { initFreeTarot(); } catch (err) { if (window.console) console.warn('[da-mobile] free tarot', err); }
    try { initMenu(); } catch (err) { if (window.console) console.warn('[da-mobile] menu', err); }
    try { initBirthCard(); } catch (err) { if (window.console) console.warn('[da-mobile] birth card', err); }
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})();
